export const report_type = 'analytical_reports_electro_docs';

export const fileTypes = {
  xlsx: 'xlsx',
  json: 'json',
};

export const reportOptions = [
  { id: 'monitoring_status_reports', label: 'Мониторинг отчетов по статусам', value: 'monitoring_status_reports' },
  {
    id: 'list_entities_accepted_reporting',
    label: 'Перечень субъектов с принятой отчетностью',
    value: 'list_entities_accepted_reporting',
  },
  { id: 'entities_type_activity', label: 'Субъекты по видам деятельности', value: 'entities_type_activity' },
  {
    id: 'mass_waste_transferred_tko',
    label: 'Масса переданных отходов региональному оператору по обращению с ТКО',
    value: 'mass_waste_transferred_tko',
  },
  {
    id: 'list_organizations_overdue_reporting',
    label: 'Перечень организаций с просроченной отчетностью',
    value: 'list_organizations_overdue_reporting',
  },
  {
    id: 'analysis_waste_fkko_codes',
    label: 'Анализ распределения отходов по кодам ФККО',
    value: 'analysis_waste_fkko_codes',
  },
  {
    id: 'consolidated_report_legal_entities',
    label: 'Сводный отчёт по юридическим лицам (индивидуальным предпринимателям), осуществлявшим приём отходов',
    value: 'consolidated_report_legal_entities',
  },
];

export const reportTitles = reportOptions.reduce((acc, curr) => ({ ...acc, [curr.id]: curr.id }), {});

export const minDate = new Date('2026-01-01');

